import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  IconButton,
  Text,
} from '@chakra-ui/react';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { MouseEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from 'theme/colors';
import { shadows } from 'theme/shadows';
import { useEditor } from 'widgets/sdk';

import { toggleAccordionExpand } from './MultipleChoicesWidgetSideMenuSettings.helpers';
import QuestionSection from './components/QuestionSection';

const QUESTION_ACCORDION_INDEX = 0;

export const MultipleChoicesWidgetSideMenuSettings = () => {
  const { closeWidgetSideMenu } = useEditor();
  const { t } = useTranslation('editor_widget_toolbar', { keyPrefix: 'multipleChoicesToolbar', useSuspense: false });
  const [expandedIndex, setExpandedIndex] = useState<number[]>([QUESTION_ACCORDION_INDEX]);

  // Setting component functions
  const handleClose = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      closeWidgetSideMenu();
    },
    [closeWidgetSideMenu],
  );

  const handleClickFilterSetting = () => {
    setExpandedIndex(toggleAccordionExpand(expandedIndex, QUESTION_ACCORDION_INDEX));
  };

  const handleDoubleClick = useCallback((e: MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <>
      <Flex
        borderTop={`8px solid ${colors.upgrade.blue[500]}`}
        borderBottom={`1px solid ${colors.gray[100]}`}
        h={12}
        placeItems={'center'}
        p={4}
        mb={4}
        onDoubleClick={handleDoubleClick} // NOTE: Fix double click will cause to show replace menu
      >
        <Box fontSize='medium' fontWeight='bold' flex='1' textAlign='left' textTransform={'capitalize'}>
          {t('settingsSideBar.multipleChoices.title')}
        </Box>
        <IconButton
          size='xs'
          aria-label={'Close menu'}
          bg='transparent'
          position='absolute'
          right='0'
          m='10px'
          icon={<CloseIcon />}
          onClick={handleClose}
        />
      </Flex>
      <Accordion
        boxShadow='settingsAccordion'
        allowMultiple
        index={expandedIndex}
        shadow={'none'}
        pb={60}
        maxHeight={'calc(100vh - 124px)'}
        overflowY={'auto'}
        onDoubleClick={handleDoubleClick}
      >
        <AccordionItem borderRadius='base' mx={4} shadow={shadows.settingsAccordion} onDoubleClick={handleDoubleClick}>
          <h2>
            <AccordionButton paddingInlineEnd={4} paddingInlineStart={4} py={3} onClick={handleClickFilterSetting}>
              <Box as='span' flex='1' textAlign='left'>
                <Text fontSize={'sm'} fontWeight='bold' w={'full'} display='block' alignSelf={'start'}>
                  {t('settingsSideBar.multipleChoices.question')}
                </Text>
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel paddingInlineEnd={4} paddingInlineStart={4} py={3} onDoubleClick={handleDoubleClick}>
            <QuestionSection />
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </>
  );
};

export default MultipleChoicesWidgetSideMenuSettings;
